import * as React from "react";

const LoadingDot2 = ({ className = "" }) => (
  <span
    className={`animate-throb h-2 w-2 rounded-full bg-current ${className}`}
  />
);

export const IconLoadingDots = () => (
  <div className="flex items-center gap-1">
    <LoadingDot2 />
    <LoadingDot2 className="animation-delay-200" />
    <LoadingDot2 className="animation-delay-400" />
  </div>
);

export default IconLoadingDots;
